import PriceStructure from "@/model/PriceStructure";
import { createTimelineEvent, initTimelineEvent } from "@/model/TimelineEvent";
import Timeslot from "@/model/Timeslot";
/**
 * Creates a new Product with default values
 */
export function createProduct() {
    return {
        bookingIntervalLength: 1,
        priceStructure: new PriceStructure(),
        resourceGroups: [],
        resources: [],
        timelineEvents: [],
        crossSells: [],
        timeslots: []
    };
}
/**
 * Initializes a Product from another Product or similar object
 */
export function initProduct(target, source) {
    // Copy all properties
    Object.assign(target, source);
    // Initialize price structure
    target.priceStructure = new PriceStructure();
    target.priceStructure.init(source.priceStructure);
    // Initialize timeline events
    target.timelineEvents = [];
    source.timelineEvents.forEach(value => {
        const timelineEvent = initTimelineEvent(createTimelineEvent(), value);
        target.timelineEvents.push(timelineEvent);
    });
    // Initialize timeslots
    target.timeslots = [];
    if (source.timeslots) {
        source.timeslots.forEach((value) => {
            const timeslot = new Timeslot();
            timeslot.assign(value);
            target.timeslots.push(timeslot);
        });
    }
    return target;
}
/**
 * Returns a list of resources of type RESOURCE that are assigned to this product, either via resource
 * groups or individual resources.
 */
export function getAssignedResources(product, type) {
    const assignedResources = [];
    assignedResources.push(...product.resources.filter(r => type === undefined || r.resourceType === type));
    product.resourceGroups.filter(rg => type === undefined || rg.resourceType === type).forEach(resourceGroup => {
        resourceGroup.resources.forEach(resource => {
            if (assignedResources.find(r => r.id === resource.id) === undefined) {
                assignedResources.push(resource);
            }
        });
    });
    // Filter out duplicates and sort by resource id
    return assignedResources.filter((item, index, self) => index === self.findIndex(t => t.id === item.id)).sort((a, b) => Number(a.id - b.id));
}
export function getResourceGroups(product, type) {
    return product.resourceGroups.filter(rg => rg.resourceType == type);
}
export function getResources(product, type) {
    return product.resources.filter(r => r.resourceType == type);
}
